export function loraError(e, fallback) {
  if (e && e.response && e.response.data) {
    const d = e.response.data
    if (typeof d === 'string' && d) return d
    if (d.message) return d.message
  }
  return fallback || 'An error occurred'
}
